module.exports = __webpack_public_path__ + "instagram_squircle_charcoal.svg?821c0f5270f337715e636a501e9873fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/instagram_squircle_charcoal.svg
// module id = 130
// module chunks = 0